import { COMPANY_CHANGED_CODE } from '@/lib/web_api/web_api_protocol';

/** Session problems the page itself resolves, by redirecting to login, MFA or setup. */
export const SESSION_REQUIRED_CODE = 'session_required';

export class WebApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string
  ) {
    super(message);
    this.name = 'WebApiError';
  }
}

/**
 * Errors only a page load resolves: a lost session, which the page redirects to login, MFA or
 * setup, or another tab switching the company, which the page reloads into.
 */
export function requiresPageReload(error: unknown): boolean {
  return error instanceof WebApiError && (error.code === SESSION_REQUIRED_CODE || error.code === COMPANY_CHANGED_CODE);
}

/** Client errors repeat the same answer, so retrying them only delays the error state. */
export function isClientWebApiError(error: unknown): boolean {
  return error instanceof WebApiError && error.status >= 400 && error.status < 500;
}
